module.exports = __webpack_public_path__ + "img/Loading.0ccd778b.png";